export default "__VITE_ASSET__DOXYFJ3R__"